var map = {
	"./CalendarBlank.svg": "7520",
	"./SpinnerGap.svg": "3b7b",
	"./ban-icon.svg": "74bd",
	"./blue-arrow.svg": "ee6a",
	"./check-circle.svg": "526d",
	"./circle-false.svg": "09a4",
	"./circle-ok.svg": "989c",
	"./clock-picker.svg": "ea51",
	"./data-rocket-circle.svg": "fe3f",
	"./download-icon.svg": "dbf3",
	"./edit-request-icon.svg": "5792",
	"./info.svg": "6e74",
	"./link-icon.svg": "b668",
	"./logout.svg": "5201",
	"./menu.svg": "f7f7",
	"./ok-request-icon.svg": "439d",
	"./shop-icon.svg": "4546",
	"./warn-icon-red.svg": "58f0",
	"./warn-icon.svg": "e16c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "034b";